import {lazy, Suspense} from "react";
import {useApplicationStore} from "../model/applicationStore";
import {User} from "@/entities/user";

const DiscountFirstOrderModal = lazy(() =>
    import('@/features/discount-firs-order-modal').then(({DiscountFirstOrderModal}) => ({
        default: DiscountFirstOrderModal,
    })),
);

const LoginOrRegistrationModal = lazy(() =>
    import('@/widgets/login-or-registration-modal').then(({LoginOrRegistrationModal}) => ({
        default: LoginOrRegistrationModal,
    })),
);

type Props = {
    user: User;
    promoCodeFirstOrder: string;
}

export const GlobalModals = (
    {
        user,
        promoCodeFirstOrder
    }: Props
) => {
    const interactionFlag = useApplicationStore((s) => s.interactionFlag);

    if (!interactionFlag) return null;

    return (
        <>
            <Suspense><DiscountFirstOrderModal promoCodeFirstOrder={promoCodeFirstOrder} /></Suspense>
            <Suspense><LoginOrRegistrationModal /></Suspense>
        </>
    );
}
